import React, { useState } from 'react';
import Button from '../../components/common/Button';
import FormField from '../../components/common/FormField';
import { RewardDTO } from '../../services/apiClient';

interface RewardFormProps {
  initialValues: RewardDTO;
  onSubmit: (data: RewardDTO) => void;
  onCancel: () => void;
}

const RewardForm: React.FC<RewardFormProps> = ({
  initialValues,
  onSubmit,
  onCancel,
}) => {
  const [formData, setFormData] = useState<RewardDTO>(initialValues);

  const handleChange = (key: keyof RewardDTO) => (value: string) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData); // Pass the updated data back to the parent
  };

  return (
    <form onSubmit={handleFormSubmit}>
      <div className="mb-4">
                <FormField
          id="name"
          label="Name"
          type="text"
          value={formData.name || ''}
          onChange={(e) => handleChange('name')(e.target.value)}
          placeholder="Enter Name"
        />
        <FormField
          id="description"
          label="Description"
          type="text"
          value={formData.description || ''}
          onChange={(e) => handleChange('description')(e.target.value)}
          placeholder="Enter Description"
        />
        <FormField
          id="startRange"
          label="Start Range"
          type="number"
          value={formData.startRange || ''}
          onChange={(e) => handleChange('startRange')(e.target.value)}
          placeholder="Enter StartRange"
        />
        <FormField
          id="endRange"
          label="End Range"
          type="number"
          value={formData.endRange || ''}
          onChange={(e) => handleChange('endRange')(e.target.value)}
          placeholder="Enter EndRange"
        />

      </div>
      <div className="flex justify-end space-x-4">
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit">Save</Button>
      </div>
    </form>
  );
};

export default RewardForm;
